
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/news",
      function () {
        return require("private-next-pages/[slug]/news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/news"])
      });
    }
  